import React, { useState, useEffect } from 'react';

const AsciiClock = ({ onClose }) => {
  const [time, setTime] = useState('');

  useEffect(() => {
    const initTime = () => {
      const now = new Date();
      const timeString = now.toLocaleTimeString('en-US', { 
        hour12: true,
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });
      
      // Simple ASCII representation (fallback since figlet is not available in React)
      const asciiTime = createAsciiTime(timeString);
      setTime(asciiTime);
    };

    initTime();
    const interval = setInterval(initTime, 1000);

    return () => clearInterval(interval);
  }, []);

  const createAsciiTime = (timeString) => {
    // Simple ASCII representation of time
    const lines = [
      '┌─────────────────┐',
      '│                 │',
      '│  ' + timeString.padStart(11) + '  │',
      '│                 │',
      '└─────────────────┘'
    ];
    
    return lines.join('\n');
  };


  return (
    <div>
      <div className="text-center">
        <h4>ASCII Digital Clock</h4>
        <div className="mt-4">
          <pre 
            style={{
              fontFamily: 'monospace',
              fontSize: '16px',
              lineHeight: '1.2',
              backgroundColor: '#f8f9fa',
              padding: '20px',
              borderRadius: '8px',
              border: '1px solid #dee2e6',
              minHeight: '120px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            {time}
          </pre>
        </div>
        
        
        <div className="mt-4">
          <p className="text-muted">
            This clock updates every second and displays the current time in ASCII format.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AsciiClock;
